module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-Semibold-029b9bc9.ttf";